<template>
  <div id="event-details" class="jf-details section padding-top-65 padding-bottom-65">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="section-headline centered margin-bottom-45">
            <h3>Event Details</h3>
            <span>Everything you need to know about the Macher Job Fair</span>
          </div>
        </div>
      </div>
      <div class="row jf-details__row">
        <div class="col-lg-6">
          <div class="jf-details__info">
            <div class="jf-details__item" v-for="(item, i) in event.highlights" :key="i">
              <div class="jf-details__icon">
                <i :class="item.icon"></i>
              </div>
              <div class="jf-details__text">
                <span>{{ item.text }}</span>
              </div>
            </div>
            <div class="jf-details__venue">
              <h4>Venue</h4>
              <p><strong>{{ event.venue }}</strong></p>
              <p>{{ event.address }}</p>
              <p class="jf-details__datetime">
                <i class="icon-feather-calendar"></i> {{ event.date }}<br>
                <i class="icon-feather-clock"></i> {{ event.time }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="jf-details__map">
            <iframe
              :src="mapUrl"
              width="100%"
              height="100%"
              style="border:0; border-radius: 8px;"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true }
  },
  computed: {
    mapUrl() {
      const query = encodeURIComponent(this.event.venue + ', ' + this.event.address);
      return `https://www.google.com/maps?q=${query}&output=embed`;
    }
  }
};
</script>

<style lang="scss" scoped>
.jf-details {
  background: #f9f9f9;

  &__row {
    display: flex;
    align-items: stretch;

    > [class*="col-"] {
      display: flex;
      flex-direction: column;
    }
  }

  &__info {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  &__icon {
    width: 50px;
    height: 50px;
    background: #2a41e8;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    flex-shrink: 0;

    i {
      color: #fff;
      font-size: 20px;
    }
  }

  &__text {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }

  &__venue {
    margin-top: auto;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    h4 {
      margin-bottom: 10px;
      color: #2a41e8;
    }

    p {
      margin-bottom: 5px;
      color: #666;
    }
  }

  &__datetime {
    margin-top: 10px;

    i {
      color: #2a41e8;
      margin-right: 6px;
    }
  }

  &__map {
    flex: 1;
    min-height: 350px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }
}
</style>
